import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './Header.css';

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
{/*PFawawfw */}
const Header: React.FC = () => {
  const location = useLocation();
  const isAboutPage = location.pathname === '/about';
  const isRoadmapPage = location.pathname === '/roadmap';
  const isMilestonesPage = location.pathname === '/milestones';
  const isChangelogPage = location.pathname === '/changelog';
  const isJoinPage = location.pathname === '/join';
  const isSurveyPage = location.pathname === '/survey';

  const getPageTitle = () => {
    if (isAboutPage) return 'О проекте';
    if (isRoadmapPage) return 'Фичи';
    if (isMilestonesPage) return 'Этапы';
    if (isChangelogPage) return 'Обновления';
    if (isJoinPage) return 'Хочу в команду';
    if (isSurveyPage) return 'Опрос';
    return null;
  };

  const pageTitle = getPageTitle();

  return (
    <header className="header">
      <div className="header__inner">
        <div className="header__logo">
          {pageTitle ? (
            <>
              <span className="header-logo"></span>
              <Link to="/" className="header__logo-link">Celestix</Link>
              <span className="header__logo-separator"> • </span>
              <span>{pageTitle}</span>
            </>
          ) : (
            <>
              <span className="header-logo"></span>
              <Link to="/" className="header__logo-link">Celestix</Link>
            </>
          )}
        </div>
        {pageTitle !== "Опрос" ? 
        (<>
        <Link className="footer__link" to="/survey" onClick={scrollToTop}>Пройти опрос</Link>
        </>)
        :
        (<>
        </>)}
      </div>
    </header>
  );
};

export default Header;